// MSL
(function () {
	// Main Wrapper
	const wrapper = document.querySelector('.msl-results');

	if (!wrapper) return;

	// Form Input
	const mslFormInput = document.getElementById('msl-search__form');
	const mslButton = mslFormInput.querySelector('.msl-search__button');
	const mslDisease = mslFormInput.querySelector('select[name="msl-disease"]');
	const mslZip = mslFormInput.querySelector('input[name="msl-zip"]');

  function scrollToCard() {
    const card = document.querySelector('.msl-card');
    if (card) {
      card.scrollIntoView({
        behavior: 'smooth',
        block: 'center'
      });
    }
  }


	// Container
	const container = document.getElementById('msl__container');

	// Disable default submit for the form
	mslFormInput.addEventListener('submit', (e) => {
		e.preventDefault();
	});
	
	// Get Form Input values and assign 
	mslButton.addEventListener('click', (e) => {
		e.preventDefault();
		handleMSLsearch();
	});

	// Function to send the query
	async function handleMSLsearch(e) {
    const mslDiseaseVal = mslDisease.value;
    const mslZipVal = mslZip.value;
    const formData = new FormData();

    formData.append('msl_disease', mslDiseaseVal);
    formData.append('msl_zipcode', mslZipVal);

    // Append action & nonce parameters
    formData.append('action', 'msl_search');
    formData.append('nonce', ajax_params.nonce);

    try {
      const response = await fetch(ajax_params.ajax_url, {
        method: 'POST',
        body: formData,
      });

      if (response.ok) {
        const { success, data } = await response.json();
        const { content } = data;

        container.innerHTML = content;

      } else {
        console.error('Error:', response.status);
      }
    } catch (error) {
      console.error('Error:', error);
    } finally {
      scrollToCard();
    }
  }

})();